import React from 'react';
import unifei from '../../assets/logotipo-unifei.png';
import capes from '../../assets/logotipo-capes.png';
//import lgi from '../../assets/logotipo-lgi.png';
//import circular from '../../assets/logotipo-circular.png';
import cnpq from '../../assets/logotipo-cnpq.png';
import fapemig from '../../assets/logotipo-fapemig.png';
import logologtrans from '../../assets/logologtrans.png';

import '../Footer/Footer.css';

function Footer() {
  return (
    <footer className='fixed-bottom-bar'>
      <p></p>
    <div className='container'> 
      <img  className='img' src={unifei} alt="unifei"/>
      <img  className='img' src={capes} alt="unifei"/>
      {/* <img  className='img' style={{width: '100px'}} src={lgi} alt="unifei"/>
      */}
      <img  className='img' style={{width: '100px'}} src={logologtrans} alt="unifei"/> 
      <img  className='img' style={{width: '100px'}} src={cnpq} alt="unifei"/>
      <img  className='img' style={{width: '100px'}} src={fapemig} alt="unifei"/>
    </div>
  </footer>
  
  ) 
  
  
}

export default Footer;